import styled from "styled-components";
import { deviceDF } from "../../utils/breakPoints";
import { BLUE_RGB } from "../../utils/colorsTheme";

const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;

  @media ${deviceDF.tablet} {
    flex-direction: column;
  }
`;

const FooterStyled = styled.div`
  font-size: 0.875rem;
  font-weight: bold;
  color: ${BLUE_RGB};
`;

const ListStyled = styled.ul`
  width: 300px;
  padding: 0 0 0 20px;
`;

const ListItemStyled = styled.li`
  margin-bottom: 0.3rem;
`;

const styles = () => ({
  thTable: {
    fontSize: ".875rem !important",
    fontWeight: "bold !important",
    color: BLUE_RGB,
  },
});

export { ColumnContainer, FooterStyled, ListStyled, ListItemStyled, styles };
